import { createClient } from "@supabase/supabase-js";

// Helper to get env vars in both Vite and Node environments
const getSupabaseConfig = () => {
  let url: string | undefined;
  let key: string | undefined;

  // Check for Vite's import.meta.env
  // We explicitly access the properties so Vite can statically replace them
  try {
    if (typeof import.meta !== "undefined" && import.meta.env) {
      url = import.meta.env.VITE_SUPABASE_URL;
      key = import.meta.env.VITE_SUPABASE_KEY;
    }
  } catch (_e) {
    // Ignore error if import.meta is not available
  }

  // Fallback to Node's process.env if available and values are missing
  try {
    if (typeof process !== "undefined" && process.env) {
      if (!url) url = process.env.VITE_SUPABASE_URL;
      if (!key) key = process.env.VITE_SUPABASE_KEY;
    }
  } catch (_e) {
    // Ignore error if process is not available
  }

  return { url, key };
};

const { url: supabaseUrl, key: supabaseKey } = getSupabaseConfig();

// Debug logging (remove in production once confirmed working)
console.log(
  "[Supabase Init] URL exists:",
  !!supabaseUrl,
  "Key exists:",
  !!supabaseKey,
);

// Create client if keys exist, otherwise export null (handled by consumers)
export const supabase =
  supabaseUrl && supabaseKey ? createClient(supabaseUrl, supabaseKey) : null;

if (!supabase) {
  console.warn("Supabase client is null. Auth features are disabled.");
}
